let postLoginSideBar = [
    // { menu: { label: 'My Portfolio', linkTo: `/dashboard`, class: "myportfolio_navicon" }, },


    // {
    //     menu: { label: 'Invest', linkTo: `/transact`, class: "invest_navicon" },
    //     subMenu: [
    //         { menu: { label: 'Basket Investment', linkTo: `/dashboard/transact/category`, class: "xyz" }, },
    //         { menu: { label: 'Lumpsum', linkTo: `/dashboard/transact/invest`, class: "xyz" }, },
    //         { menu: { label: 'Lumpsum - Cashflow', linkTo: `/dashboard/transact/investCash`, class: "xyz" }, },
    //         { menu: { label: 'SIP', linkTo: `/dashboard/transact/sip`, class: "xyz" }, },
    //     ]
    // },
    // {
    //     menu: { label: 'Allocate in Demat', linkTo: ``, class: "aldemat_navicon" },
    //     subMenu: [
    //         { menu: { label: 'Lumpsum', linkTo: ``, class: "_ac" }, },
    //         { menu: { label: 'SIP', linkTo: ``, class: "_ac" }, },
    //     ]
    // },
    //{ menu: { label: 'Goal Based Investment', linkTo: ``, class:"goalbase_navicon" }, },
    // {
    //     menu: { label: 'Redemption', linkTo: ``, class: "redemption_navicon" },
    //     subMenu: [
    //         { menu: { label: 'Sell', linkTo: `/dashboard/transact/redeem`, class: "_ac" }, },
    //         { menu: { label: 'SWP', linkTo: `/dashboard/transact/SWP`, class: "_ac" }, },
    //     ]
    // },
    // {
    //     menu: { label: 'Transfer', linkTo: ``, class: "transfer_navicon" },
    //     subMenu: [
    //         { menu: { label: 'Switch', linkTo: `/dashboard/transact/switch`, class: "_ac" }, },
    //         { menu: { label: 'STP', linkTo: `/dashboard/transact/stp`, class: "_ac" }, },
    //     ]
    // },
    // {
    //     menu: { label: 'Scheduled Investments', linkTo: ``, class:"mnschedule_navicon" },
    //     subMenu: [
    //         {
    //             menu: {
    //                 label: 'SIP', linkTo: '/dashboard/systematicPlan', class: "_ac"
    //             }
    //         },
    //         {
    //             menu: {
    //                 label: 'SWP', linkTo: '/dashboard/systematicPlanSWP', class: "_ac"
    //             }
    //         },
    //         {
    //             menu: {
    //                 label: 'STP', linkTo: '/dashboard/systematicPlanSTP', class: "_ac"
    //             }
    //         },
    //     ]
    // },
    // {
    //     menu: { label: 'Smart Plans', linkTo: ``, class: "smartplan_navicon" },
    //     subMenu: [
    //         { menu: { label: 'Movi pack plan', linkTo: ``, class: "_ac" }, },
    //         { menu: { label: 'Cash flow plan', linkTo: ``, class: "_ac" }, },
    //         { menu: { label: 'Large cap alpha index plan', linkTo: ``, class: "_ac" }, },
    //     ]
    // },

    // { menu: { label: 'Orderbook', linkTo: `/dashboard/TrackOrder`, class: "orderbook_navicon" }, },
    // {
    //     menu: { label: 'Manage Profile', linkTo: ``, class: "managepr_navicon" },
    //     subMenu: [
    //         { menu: { label: 'Change password', linkTo: ``, class: "_ac" }, },
    //         { menu: { label: 'Hint Question', linkTo: ``, class: "_ac" }, },
    //         { menu: { label: 'Email/Mobile', linkTo: ``, class: "_ac" }, },
    //     ]
    // },
    {
        menu: { label: 'Reports', linkTo: ``, class: "report_navicon" },
        subMenu: [
            { menu: { label: 'Account Statement', linkTo: `${process.env.REACT_APP_PORTAL_AIF_ABSOLUTE_URL}/reports/account-statement`, class: "_ac" }, },
            { menu: { label: 'PPM', linkTo: `${process.env.REACT_APP_PORTAL_AIF_ABSOLUTE_URL}/reports/ppm`, class: "_ac" }, },
            { menu: { label: 'Newsletter', linkTo: `${process.env.REACT_APP_PORTAL_AIF_ABSOLUTE_URL}/reports/aif-news-letter`, class: "_ac" }, },
            { menu: { label: 'Tax Letter', linkTo: `${process.env.REACT_APP_PORTAL_AIF_ABSOLUTE_URL}/reports/tax-letter`, class: "_ac" }, },
            { menu: { label: 'Querterly Insight', linkTo: `${process.env.REACT_APP_PORTAL_AIF_ABSOLUTE_URL}/reports/quarterly-insights`, class: "_ac" }, },

        ]
    },
    {
        menu: { label: 'Manage Account', linkTo: ``, LinkFlag: true, class: "report_navicon" },
        subMenu: [
            { menu: { label: 'Add E-mandate', linkTo: `/emandate`, class: "_ac" }, },


        ]
    },
    // {
    //     menu: { label: 'Manage Account', linkTo: ``, class: "manageac_navicon" },
    //     subMenu: [
    //         { menu: { label: 'Add Bank', linkTo: `/dashboard/manageaccount/addbankaccount`, class: "_ac" }, },
    //         { menu: { label: 'Add Mandate', linkTo: `/dashboard/manageaccount/addmandate`, class: "_ac" }, },

    //     ]
    // }
];

export default postLoginSideBar;